import React, { Component } from "react"
import Button from "../../components/Button"
import TextField from "../../components/TextField"
import validator from "validator"
import qs from "qs"
import { redirectOnTrialFirstLogin } from "./helpers"
import { colorLogo } from "../../shared/images"
import { login } from "../../shared/auth"

import "./login.scss"

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: "",
      password: "",
      errors: {},
      hasFocused: false,
    }
  }

  updateField = (field) => (e) => {
    e.persist()

    this.setState(({ errors }) => ({
      [field]: e.target.value,
      errors: { ...errors, [field]: null, submit: null },
    }))
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)

    this.setState({
      redirect_url: urlParams.get("redirect_url")
        ? urlParams.get("redirect_url")
        : null,
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    let { email, password, errors } = this.state

    if (!email) {
      errors.email = "Email Required"
    } else if (!validator.isEmail(email)) {
      errors.email = "Invalid Email"
    }

    if (!password) {
      errors.password = "Password Required"
    }

    if (Object.values(errors).some((value) => !!value)) {
      this.setState({ errors })
      return
    }

    login(email, password)
      .then(({ data }) => {
        let { payload, message } = data.login.response

        if (payload === "passwordResetNeeded") {
          const search = qs.stringify(
            { token: message },
            { addQueryPrefix: true }
          )
          const resetPasswordURL = new URL(
            `${window.location.origin}/reset-password${search}`
          )
          window.location.replace(resetPasswordURL)
        } else if (
          payload === "unknownUser" ||
          payload === "accountDeactivated" ||
          payload === "invalidCreds"
        ) {
          this.setState(({ errors }) => ({
            errors: { ...errors, submit: message },
          }))
        } else if (redirectOnTrialFirstLogin(data.login)) {
          return window.location.replace("/marketplace")
        } else if (this.props.location.pathname === "/login") {
          const { from, search } = this.props.location.state || {
            from: { pathname: "/" },
          }
          let redirectURL = (from.pathname || from || "") + (search || "")
          window.location.replace(redirectURL)
        } else {
          window.location.replace("/")
        }
      })
      .catch((err) => {
        console.log("login error", err)
        this.setState(({ errors }) => ({
          errors: { ...errors, submit: "Unable to process your request." },
        }))
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearFields !== prevProps.clearFields) {
      this.setState({
        email: "",
        password: "",
        errors: {},
        hasFocused: false,
      })
    }
  }

  handleFocus = () => {
    this.setState({
      hasFocused: true,
    })
  }

  render() {
    let { errors } = this.state

    const inputData = (field) => ({
      value: this.state[field],
      fullWidth: true,
      errors: true,
      errorOptions: {
        outline: true,
        showMessage: true,
        message: errors[field],
        hasError: !!errors[field],
      },
      onChange: this.updateField(field),
      onChangeFocus: this.handleFocus,
      hasFocused: this.state.hasFocused,
      onBlur: () => null,
    })

    let inputFields = [
      {
        ...inputData("email"),
        type: "email",
        name: "email",
        shouldAutofocus: false,
        placeholder: "Email Address",
        autocomplete: "on",
        dataCy: "login-form-email",
      },
      {
        ...inputData("password"),
        type: "password",
        name: "password",
        shouldAutofocus: false,
        placeholder: "Password",
        dataCy: "login-form-password",
      },
    ]

    return (
      <div className="login">
        <div className="logo">
          <img src={colorLogo} alt="ETR" className="logo-md" />
        </div>
        <form className="login-form" tabIndex="0">
          {inputFields.map((input, i) => (
            <TextField key={i} {...input} />
          ))}
          {errors.submit && (
            <div className="loginError">
              <p>{errors.submit}</p>
            </div>
          )}
          {this.props.forgotPassword && (
            <div id="forgot-password-link" onClick={this.props.forgotPassword}>
              Forgot Password?
            </div>
          )}
          <Button
            type="submit"
            classes={["primary"]}
            action={this.onSubmit}
            fullWidth
            text="Sign In"
            data-cy="login-form-submit"
          />
          <p>
            Not a member yet?{" "}
            <a href="https://etr.ai/request-a-free-trial">Sign up</a>
          </p>
        </form>
      </div>
    )
  }
}

export default Login
